import { render, staticRenderFns } from "./EditUser.vue?vue&type=template&id=87faa8f0&scoped=true"
import script from "./EditUser.vue?vue&type=script&lang=js"
export * from "./EditUser.vue?vue&type=script&lang=js"
import style0 from "./EditUser.vue?vue&type=style&index=0&id=87faa8f0&prod&lang=css"
import style1 from "./EditUser.vue?vue&type=style&index=1&id=87faa8f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87faa8f0",
  null
  
)

export default component.exports